import msf from '../services/msfService';
import { ActionTypes } from '../constants';
import { asyncAction, asyncCall } from "./commonActions";

export const getSurveys = (appCode, searchString = null, skip = null, limit = null) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_MSF_SURVEY_LIST_REQUEST,
        success: ActionTypes.GET_MSF_SURVEY_LIST_SUCCESS,
        failure: ActionTypes.GET_MSF_SURVEY_LIST_FAILURE
    },
    serviceAction: msf.getSurveys,
    appCode,
    searchString,
    skip,
    limit
});

export const getSurveyDetails = (appCode, id) => asyncAction({
    actionTypes:{
        request: ActionTypes.GET_MSF_SURVEY_REQUEST,
        success: ActionTypes.GET_MSF_SURVEY_SUCCESS,
        failure: ActionTypes.GET_MSF_SURVEY_FAILURE
    },
    serviceAction: msf.getSurveyDetails,
    appCode,
    id
});

export const addSurvey = (appCode, params) => asyncAction({
    actionTypes:{
        request: ActionTypes.ADD_MSF_SURVEY_REQUEST,
        success: ActionTypes.ADD_MSF_SURVEY_SUCCESS,
        failure: ActionTypes.ADD_MSF_SURVEY_FAILURE
    },
    serviceAction: msf.addSurvey,
    appCode,
    params
});

export const updateSurvey = (appCode, id, params) => asyncAction({
    actionTypes:{
        request: ActionTypes.UPDATE_MSF_SURVEY_REQUEST,
        success: ActionTypes.UPDATE_MSF_SURVEY_SUCCESS,
        failure: ActionTypes.UPDATE_MSF_SURVEY_FAILURE
    },
    serviceAction: msf.updateSurvey,
    appCode,
    id,
    params
});

export const deleteSurvey = (appCode, id) => asyncAction({
    actionTypes:{
        request: ActionTypes.DELETE_MSF_SURVEY_REQUEST,
        success: ActionTypes.DELETE_MSF_SURVEY_SUCCESS,
        failure: ActionTypes.DELETE_MSF_SURVEY_FAILURE
    },
    serviceAction: msf.deleteSurvey,
    appCode,
    id
});

export const getSurveyTypes = (appCode) => asyncAction({
    actionTypes:{
        request: ActionTypes.GET_MSF_SURVEY_TYPES_REQUEST,
        success: ActionTypes.GET_MSF_SURVEY_TYPES_SUCCESS,
        failure: ActionTypes.GET_MSF_SURVEY_TYPES_FAILURE
    },
    serviceAction: msf.getSurveyTypes,
    appCode
});

export const applySurveyAction = (appCode, id, params) => asyncAction({
    actionTypes:{
        request: ActionTypes.APPLY_MSF_SURVEY_ACTION_REQUEST,
        success: ActionTypes.APPLY_MSF_SURVEY_ACTION_SUCCESS,
        failure: ActionTypes.APPLY_MSF_SURVEY_ACTION_FAILURE
    },
    serviceAction: msf.applySurveyAction,
    appCode,
    id,
    params
});

export const getSurveyReport = (appCode, id) => asyncAction({
    actionTypes:{
        request: ActionTypes.GET_MSF_SURVEY_REPORT_REQUEST,
        success: ActionTypes.GET_MSF_SURVEY_REPORT_SUCCESS,
        failure: ActionTypes.GET_MSF_SURVEY_REPORT_FAILURE
    },
    serviceAction: msf.getSurveyReport,
    appCode,
    id
});

export const downloadSurveyReport = (appCode, url, onSuccess) => {
    const serviceFunction = async (accessToken) => {
        msf.downloadSurveyReport({ url, accessToken }).then((blob) => {
            onSuccess(blob);
        });
    };
    return asyncCall(appCode, serviceFunction);
};

export const getQuestionnaires = (appCode, searchString = null, skip = null, limit = null) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_MSF_QUESTIONNAIRE_LIST_REQUEST,
        success: ActionTypes.GET_MSF_QUESTIONNAIRE_LIST_SUCCESS,
        failure: ActionTypes.GET_MSF_QUESTIONNAIRE_LIST_FAILURE
    },
    serviceAction: msf.getQuestionnaires,
    appCode,
    searchString,
    skip,
    limit
});

export const getQuestionnaireDetails = (appCode, id) => asyncAction({
    actionTypes:{
        request: ActionTypes.GET_MSF_QUESTIONNAIRE_REQUEST,
        success: ActionTypes.GET_MSF_QUESTIONNAIRE_SUCCESS,
        failure: ActionTypes.GET_MSF_QUESTIONNAIRE_FAILURE
    },
    serviceAction: msf.getQuestionnaireDetails,
    appCode,
    id
});

export const updateQuestionnaire = (appCode, id, params) => asyncAction({
    actionTypes:{
        request: ActionTypes.UPDATE_MSF_QUESTIONNAIRE_REQUEST,
        success: ActionTypes.UPDATE_MSF_QUESTIONNAIRE_SUCCESS,
        failure: ActionTypes.UPDATE_MSF_QUESTIONNAIRE_FAILURE
    },
    serviceAction: msf.updateQuestionnaire,
    appCode,
    id,
    params
});

export const getFacilitators = (appCode) => asyncAction({
    actionTypes:{
        request: ActionTypes.GET_MSF_FACILITATORS_REQUEST,
        success: ActionTypes.GET_MSF_FACILITATORS_SUCCESS,
        failure: ActionTypes.GET_MSF_FACILITATORS_FAILURE
    },
    serviceAction: msf.getFacilitators,
    appCode
});

export const getRecipients = (appCode, params) => asyncAction({
    actionTypes:{
        request: ActionTypes.GET_MSF_RECIPIENTS_REQUEST,
        success: ActionTypes.GET_MSF_RECIPIENTS_SUCCESS,
        failure: ActionTypes.GET_MSF_RECIPIENTS_FAILURE
    },
    serviceAction: msf.getRecipients,
    appCode,
    params
});


const msfActions = {
    getSurveys,
    getSurveyDetails,
    addSurvey,
    updateSurvey,
    deleteSurvey,
    applySurveyAction,
    getSurveyReport,
    downloadSurveyReport,
    getSurveyTypes,
    getQuestionnaires,
    getQuestionnaireDetails,
    updateQuestionnaire,
    getFacilitators,
    getRecipients
};

export default msfActions;
